import * as React from "react";
import dayjs from "dayjs";
import { TableStore } from "src/components/tables/TableStore";
import { Input, Select } from "antd";
import { AColumn } from "src/components/tables/AsyncTable";
import { singleLoader } from "src/components/tables/singleLoader";
import { filterItem, FiltersFormItem } from "src/components/tables/FiltersForm";
import { refSorter } from "src/components/tables/clientSorting";
import {
  FiltersFactory,
  makeFilters,
  testList,
  testStrStart,
} from "src/components/tables/clientFiltering";
import { delay } from "src/common/delay";
import { InputNumberStd } from "src/components/InputNumberStd";
import { TableFacade } from "./TableFacade";

const countryRef: Record<string, string> = {
  be: "Беларусь",
  bn: "Бруней",
  eg: "Египет",
  es: "Испания",
  fr: "Франция",
  gr: "Греция",
  hu: "Венгрия",
  it: "Италия",
  kh: "Камбоджа",
  mm: "Мьянма",
  my: "Малайзия",
  mx: "Мексика",
  pt: "Португалия",
  ru: "Россия",
  sg: "Сингапур",
  th: "Таиланд",
  tz: "Танзания",
  vn: "Вьетнам",
};
const countryOptions = Object.entries(countryRef).map(([value, label]) => ({
  value,
  label,
}));
countryOptions.sort((a, b) => a.label.localeCompare(b.label));

interface MyData {
  id: number;
  name: string;
  count: number;
  country: string;
  beginDate: string;
}

const volwes = "aoiue";
const consonants = "bcdfghjklmnprstvwxyz";
const genLetter = (letters: string) =>
  letters[Math.floor(Math.random() * letters.length)]!;
const genWord = (min: number, max: number, pEnd: number) => {
  const n = Math.floor((max - min) * Math.random()) + min;
  const end = Math.random() < pEnd;
  let res = "";
  for (let i = 0; i < n; i++) {
    res += genLetter(consonants);
    res += genLetter(volwes);
  }
  if (end) res += genLetter(consonants);
  return res;
};
const countryCodes = Object.keys(countryRef);
const genCountryCode = (): string =>
  countryCodes[Math.floor(Math.random() * countryCodes.length)]!;

const genDate = (): string => {
  const now = dayjs();
  const start = now.subtract(2, "years");
  const finish = now.add(1, "year");
  const t0: number = start.valueOf();
  const t1: number = finish.valueOf();
  const rnd = dayjs(t0 + Math.random() * (t1 - t0));
  return rnd.format();
};

const cap = (name: string): string =>
  name.slice(0, 1).toUpperCase() + name.slice(1);
const myData: MyData[] = [];
for (let i = 0; i < 500; i++)
  myData.push({
    id: i + 1,
    name: cap(genWord(2, 6, 0.5)),
    count: Math.floor(Math.random() * 1000),
    country: genCountryCode(),
    beginDate: genDate(),
  });

const fakeLoad = async () => {
  await delay(1000);
  return myData;
};

interface MyFilters {
  name?: string;
  countryCodes?: string[];
  minCount?: number;
  maxCount?: number;
}

const filtersFactory: FiltersFactory<MyData, MyFilters> = {
  name: testStrStart("name", true),
  countryCodes: testList("country"),
  minCount: (row, filterValue) => row.count >= filterValue,
  maxCount: (row, filterValue) => row.count <= filterValue,
};

const sorters = { country: refSorter("country", countryRef) };

const fnLoad = singleLoader(fakeLoad, makeFilters(filtersFactory), sorters);

const store1 = new TableStore({
  rowKey: "id",
  fnLoad,
  settingsKey: "DemoTable",
  initialParams: { sort: "count", sortOrder: "ascend" },
});

const columns: AColumn<MyData>[] = [
  { key: "name", dataIndex: "name", title: "Имя", sorter: false },
  {
    key: "count",
    dataIndex: "count",
    title: "Количество",
    sorter: true,
    width: "20%",
  },
  {
    key: "country",
    dataIndex: "country",
    title: "Страна",
    sorter: true,
    width: "30%",
    render: (code: string) => countryRef[code],
  },
  {
    key: "beginDate",
    dataIndex: "beginDate",
    title: "Дата начала",
    sorter: true,
    render: (value: string) => (
      <span style={{ whiteSpace: "nowrap" }}>{value}</span>
    ),
  },
];

export const DemoTable = () => {
  const filterItems: Partial<Record<keyof MyFilters, FiltersFormItem>> = {
    name: filterItem(Input, { placeholder: "Имя", allowClear: true }),
    minCount: filterItem(InputNumberStd, {
      placeholder: "Мин. кол-во",
      style: { width: 120 },
    }),
    maxCount: filterItem(InputNumberStd, {
      placeholder: "Макс. кол-во",
      style: { width: 120 },
    }),
    countryCodes: filterItem(Select, {
      mode: "tags",
      options: countryOptions,
      allowClear: true,
      placeholder: "Страна",
      maxTagCount: "responsive",
      style: { minWidth: 150, maxWidth: 250 },
    }),
  };
  return (
    <div style={{ padding: 32 }}>
      <TableFacade
        store={store1}
        columns={columns}
        showSettings
        freezeLine
        filterItems={filterItems}
      />
    </div>
  );
};
